<template>
	<v-menu auto>
		<template v-slot:activator="{ on }">
			<v-btn class="menu-icon" color="ocean" icon @click="on.click">
				<v-icon>fas fa-plus</v-icon>
			</v-btn>
		</template>

		<v-list>
			<v-list-item v-if="fnAddDate" @click="fnAddDate">
				<v-list-item-icon>
					<v-icon color="ocean">far fa-calendar-alt</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Date</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fnAddTime" @click="fnAddTime">
				<v-list-item-icon>
					<v-icon color="ocean">far fa-clock</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Time</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fnAddInterval" @click="fnAddInterval">
				<v-list-item-icon>
					<v-icon color="ocean">fas fa-hourglass-half</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Interval</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-divider v-if="showDivider" />

			<v-list-item v-if="fnAddVarCondition" @click="fnAddVarCondition">
				<v-list-item-icon>
					<v-icon color="ocean">fas fa-stream</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Variable</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fnAddEventCondition" @click="fnAddEventCondition">
				<v-list-item-icon>
					<v-icon color="ocean">fas fa-plug</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Event</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<template v-if="fnAddOrBlock">
				<v-divider />

				<v-list-item @click="fnAddOrBlock">
					<v-list-item-icon>
						<span class="or">OR</span>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Add <b>"or"</b> block</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-list>
	</v-menu>
</template>

<style lang="scss" scoped>
.or {
	font-weight: bold;
	color: var(--v-ocean-base);
}
</style>

<script>
export default {
	props: {
		fnAddDate: { type: Function, required: false },
		fnAddTime: { type: Function, required: false },
		fnAddVarCondition: { type: Function, required: false },
		fnAddEventCondition: { type: Function, required: false },
		fnAddInterval: { type: Function, required: false },
		fnAddOrBlock: { type: Function, required: false },
	},

	computed: {
		showDivider() {
			// Has at least one each of date/time and general conditions, so show a
			// divider between the two groups.
			return (
				(this.fnAddDate || this.fnAddTime ||
					this.fnAddInterval) &&
				(this.fnAddVarCondition ||
					this.fnAddEventCondition)
			);
		},
	},
};
</script>
